<app-header></app-header>

<div class="d-none-conditional-wrapper" [ngClass]="{ 'd-none': isModalOpen }">
  <a id="leftnav" class="vcal-btn"><span>Menu</span></a>
  <app-leftsidebar [activePath]="activePath"></app-leftsidebar>
</div>

<div class="cp-main-sec">
  <div class="cp-herobanner">
    <img src="assets/images/cpbanner.png" alt="" />
  </div>
  @if (creatorDetailsForm) {
    <div class="right-sec" [class.right-slide]="isClassAdded" [class.no-sidebar]="isModalOpen">
      <form [formGroup]="creatorDetailsForm" (ngSubmit)="onSave()">
        <div class="right-sec-m" [ngClass]="{ 'p-0': isModalOpen, 'm-0': isModalOpen }">
          <div class="cc-right-sec-bg">
            <div class="cc-sec-heading">
              <h1 [class.is-placeholder]="!titleDynamicVal">
                {{ titleDynamicVal || (params === 'edit' ? 'Edit content' : 'New content') }}
              </h1>
              <div class="cc-btn-sec-row" [ngClass]="{ 'justify-content-end': !contentData && !params }">
                @if (contentData) {
                  <button class="btn btn-dark see-store-btn" type="button"
                  (click)="openInStore(this.contentData)">See in store</button>
                }
                <div class="cc-btn-sec">
                  @if (isEditable) {
                    <button class="btn btn-theme btn-sm save-button" (click)="onSave()" type="button">
                      {{ isSaving ? "Saving..." : "Save" }}
                    </button>
                  }
                  @if (params && params == 'edit') {
                    <button class="btn btn-green btn-sm download-button" (click)="onDownload()"
                      type="button">
                      @if (!downloading) {
                        Download
                      }
                      @if (downloading) {
                        <div class="spinner-border spinner-border-sm text-light me-2"></div>
                        Downloading...
                      }
                    </button>
                  }
                  <a class="btn btn-dark btn-sm back-button" (click)="onBack()">
                    {{ backing ? "Loading..." : "Back" }}
                  </a>
                </div>
              </div>
            </div>
            <div class="content-heading">required information</div>
            @if (errorMessage.length > 0) {
              <div class="error">
                The {{ errorMessage }} field is either empty or contains an invalid
                value. Please correct it.
              </div>
            }
            <div class="acc-top-main">
              <div class="acc-card-left-sec">
                <div class="acc-card overview">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center justify-content-between gap-3 w-100">
                      <h4>Overview</h4>
                      <div class="d-flex  align-items-center justify-content-end gap-3">
                        @if (contentData?.module_rating >=0) {
                          <div class="acc-star-rating">
                            <ngb-rating [(rate)]="moduleRating" [readonly]="true" [max]="5" class="custom-rating"></ngb-rating>
                          </div>
                        }
                        @if (contentData && contentData.pins?.length>0) {
                          <button class="btn btn-dark btn-sm"
                          (click)="constructUrlAndNavigate(contentData?.pins[0])">See on Map</button>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="cf-body">
                    <!-- one 3-column grid for the whole card, labels above their fields -->
                    <div class="cf-grid cf-grid--3">
                      <div class="cf-field cf-span-2">
                        <span class="cf-label">Title @if (creatorDetailsForm.get('content_title')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                        <input type="text" formControlName="content_title" [(ngModel)]="titleDynamicVal"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                      <div class="cf-field">
                        <span class="cf-label">Price ($)</span>
                        <input type="number" min="0" formControlName="price" />
                      </div>
                    </div>
                    @if (storeState?.store_enabled) {
                      <div class="acc-store-panel" [class]="'is-' + storeState.state">
                        <div class="acc-store-status">
                          <span class="acc-store-label">Store</span>
                          @switch (storeState.state) {
                            @case ('private') {
                              <span>Private — only you can use this in your games.</span>
                            }
                            @case ('in_store') {
                              <span>In the store for ${{ storeState.price }}.</span>
                            }
                            @case ('draft') {
                              <span>
                                Waiting to go live —
                                <a routerLink="/marketplace/vendor-onboarding">{{
                                  storeState.blocked_reason === 'payouts_required'
                                    ? 'finish your payout setup'
                                    : 'accept the seller agreement'
                                }}</a>.
                              </span>
                            }
                            @case ('hidden') {
                              <span>Hidden from the store — past buyers keep access.</span>
                            }
                          }
                        </div>
                        @if (storeState.state === 'in_store' || storeState.state === 'draft') {
                          <button type="button" class="btn btn-outline btn-sm" [disabled]="storeBusy" (click)="setSelling(false)">
                            Stop selling
                          </button>
                        } @else {
                          <button type="button" class="btn btn-green btn-sm" [disabled]="storeBusy" (click)="setSelling(true)">
                            {{ storeState.state === 'hidden' ? 'Sell again' : 'Sell in store' }}
                          </button>
                        }
                      </div>
                    }
                    <div class="cf-grid cf-grid--3">
                      <div class="cf-field">
                        <span class="cf-label">Game Genre @if (creatorDetailsForm.get('game_genre')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                        <ng-select class="wt-select" formControlName="game_genre" (change)="onGameGenreChange(creatorDetailsForm.get('game_genre')?.value)" [items]="gameGenereList"
                        bindValue="label" bindLabel="label" placeholder="Game Genre" [clearable]="false" appendTo="body">
                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Game Genre' }}</span></ng-template>
                        </ng-select>
                      </div>
                      <div class="cf-field">
                        <span class="cf-label">Game System @if (creatorDetailsForm.get('game_system')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                        <ng-select [items]="selectedGameGenreCategoryItems" bindLabel="value" bindValue="value" [multiple]="true"
                        [closeOnSelect]="false" formControlName="game_system" placeholder="Game Systems"
                        class="wt-select limited-height-select" appendTo="body" [hideSelected]="false">
                        </ng-select>
                      </div>
                      <div class="cf-field">
                        <span class="cf-label">Content Type @if (creatorDetailsForm.get('type')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                        <ng-select class="wt-select" formControlName="type" [items]="gameTypeData"
                        bindValue="value" bindLabel="value" placeholder="Select Content Type" [clearable]="false" appendTo="body">
                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Select Content Type' }}</span></ng-template>
                        </ng-select>
                      </div>
                      <div class="cf-field">
                        <span class="cf-label">Players @if (creatorDetailsForm.get('party_min_size')?.invalid || creatorDetailsForm.get('party_max_size')?.invalid) {<span class="required-star">*</span>}</span>
                        <div class="cf-range">
                          <input type="number" min="0" formControlName="party_min_size" aria-label="Fewest players" />
                          <span>to</span>
                          <input type="number" min="0" formControlName="party_max_size" aria-label="Most players" />
                        </div>
                      </div>
                      <div class="cf-field">
                        <span class="cf-label">Average level @if (creatorDetailsForm.get('partyaverage')?.errors?.['required'] || creatorDetailsForm.get('partyaverage')?.errors?.['notZero']) {<span class="required-star">*</span>}</span>
                        <input type="number" min="0" formControlName="partyaverage" />
                      </div>
                      <div class="cf-field">
                        <span class="cf-label">Playtime (hrs) @if (creatorDetailsForm.get('playtime')?.errors?.['required'] || creatorDetailsForm.get('playtime')?.errors?.['notZero']) {<span class="required-star">*</span>}</span>
                        <input type="number" min="0" formControlName="playtime" />
                      </div>
                      <div class="cf-field cf-span-2">
                        <span class="cf-label">Languages @if (creatorDetailsForm.get('languages')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                        <ng-select [items]="languageLevels" [multiple]="true" [closeOnSelect]="false" formControlName="languages"
                        placeholder="Select Language" class="wt-select limited-height-select" appendTo="body" [hideSelected]="false">
                        </ng-select>
                      </div>
                      <div class="cf-field">
                        <span class="cf-label">Content Rating @if (creatorDetailsForm.get('content_rating')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                        <ng-select class="wt-select" formControlName="content_rating" [items]="contentWarnings"
                        bindValue="label" bindLabel="label" placeholder="Select Content Rating" [clearable]="false" appendTo="body">
                        <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Select Content Rating' }}</span></ng-template>
                        <ng-template ng-option-tmp let-item="item"><span [title]="item.description || ''">{{ item.label }}</span></ng-template>
                        </ng-select>
                      </div>
                      @if (coords?.length > 0) {
                        <div class="cf-field cf-span-all">
                          <span class="cf-label">Characters @if (creatorDetailsForm.get('characters')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                          <ng-select [items]="characters" bindLabel="display_name" bindValue="id" [multiple]="true" [closeOnSelect]="false"
                            formControlName="characters" placeholder="Select Characters" class="wt-select limited-height-select" appendTo="body" [hideSelected]="false"
                            (change)="onCharacterChange($event)">
                            <ng-template ng-option-tmp let-item="item">
                              @if (item.id === 'CREATE_NEW' && !params) {
                                <span style="color: #183d5c; font-weight: bold"
                                  class="d-flex align-items-center">
                                  <svg width="24" height="24" viewBox="0 0 24 24"
                                    style="vertical-align: middle; margin-right: 4px; fill: #183d5c;">
                                    <path d="M12 5v14m7-7H5" stroke="#183d5c" stroke-width="2" fill="none" stroke-linecap="round"/>
                                  </svg>
                                  {{ item.display_name }}
                                </span>
                              }
                              @if (item.id !== 'CREATE_NEW') {
                                <span>{{ item.display_name }}</span>
                              }
                            </ng-template>
                          </ng-select>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="acc-card aiuse">
                  <h4>AI Usage</h4>
                  <div class="cf-grid cf-grid--2">
                    <div class="cf-field">
                      <span class="cf-label">AI text generator @if (creatorDetailsForm.get('ai_text_tool_usage_percentage')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                      <div class="cf-ai">
                        <div class="form-check-b">
                          <input type="checkbox" formControlName="ai_text_generator_used" aria-label="AI text generator used" />
                        </div>
                        <span class="cf-muted">Used</span>
                        <input type="number" min="0" max="100" formControlName="ai_text_tool_usage_percentage"
                          [disabled]="!this.creatorDetailsForm.get('ai_text_generator_used')?.value" aria-label="AI text generator percent used" />
                        <span class="cf-muted">% of the content</span>
                      </div>
                      @if (creatorDetailsForm.get('ai_text_tool_usage_percentage')?.invalid && (creatorDetailsForm.get('ai_text_tool_usage_percentage')?.touched || creatorDetailsForm.get('ai_text_tool_usage_percentage')?.dirty)) {
                        <div class="error-block">
                          @if (creatorDetailsForm.get('ai_text_tool_usage_percentage')?.errors?.['min']) {
                            <div class="text-danger">Value must be at least 0.</div>
                          }
                          @if (creatorDetailsForm.get('ai_text_tool_usage_percentage')?.errors?.['max']) {
                            <div class="text-danger">Value cannot exceed 100.</div>
                          }
                        </div>
                      }
                    </div>
                    <div class="cf-field">
                      <span class="cf-label">AI image generator @if (creatorDetailsForm.get('ai_image_tool_usage_percentage')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                      <div class="cf-ai">
                        <div class="form-check-b">
                          <input type="checkbox" formControlName="ai_image_generator_used" id="cb6" aria-label="AI image generator used" />
                        </div>
                        <span class="cf-muted">Used</span>
                        <input type="number" min="0" max="100" formControlName="ai_image_tool_usage_percentage"
                          [disabled]="!this.creatorDetailsForm.get('ai_image_generator_used')?.value" aria-label="AI image generator percent used" />
                        <span class="cf-muted">% of the content</span>
                      </div>
                      @if (creatorDetailsForm.get('ai_image_tool_usage_percentage')?.invalid && (creatorDetailsForm.get('ai_image_tool_usage_percentage')?.touched || creatorDetailsForm.get('ai_image_tool_usage_percentage')?.dirty)) {
                        <div class="error-block">
                          @if (creatorDetailsForm.get('ai_image_tool_usage_percentage')?.errors?.['min']) {
                            <div class="text-danger">Value must be at least 0.</div>
                          }
                          @if (creatorDetailsForm.get('ai_image_tool_usage_percentage')?.errors?.['max']) {
                            <div class="text-danger">Value cannot exceed 100.</div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                    
                  </div>
                  <div class="portrait">
                    <div class="port-header">
                      <div class="header-div">
                        <h4>Portrait</h4>
                        @if (
                          creatorDetailsForm.get('cover_image')?.errors?.[
                          'required'
                          ]
                          ) {
                          <span class="required-star">*</span>
                        }
                      </div>
                      <div class="btn-generate-sec">
                        @if (params && params === 'edit') {
                          <button class="btn btn-dark" (click)="generatePortrait($event)">
                            <img src="assets/icons/icon-generate.svg" alt="" />
                          </button>
                        }
                      </div>
                    </div>
                    <div class="profile-generate-main">
                      <!-- Empty State -->
                      @if (!contentPotrait) {
                        <div class="pg-profile-file"
                          (click)="contentData && (contentData.access_type && contentData.access_type.toLowerCase() !== 'creator') ? $event.stopPropagation() : fileInputPotrait.click()"
                          [style.cursor]="contentData && (contentData.access_type && contentData.access_type.toLowerCase() !== 'creator') ? 'not-allowed' : 'pointer'">
                          <input type="file" accept="image/*" name="file" id="file1" #fileInputPotrait
                            (change)="handleGameChangePotrait($event)" hidden />
                            <label>
                              <img src="assets/icons/icon-line-profile-cc.svg" alt="" />
                            </label>
                          </div>
                        } @else {
                          <div class="pg-profile-big"
                            (click)="contentData && (contentData.access_type && contentData.access_type.toLowerCase() !== 'creator') ? $event.stopPropagation() : fileInputPotraitImage.click()"
                            [style.cursor]="contentData && (contentData.access_type && contentData.access_type.toLowerCase() !== 'creator') ? 'not-allowed' : 'pointer'">
                            <input type="file" accept="image/*" name="file" id="file2" (change)="handleGameChangePotrait($event)"
                              #fileInputPotraitImage hidden />
                              <label>
                                <img [src]="resolveImageSrc(contentPotrait)" alt="portrait image" />
                              </label>
                            </div>
                          }
                          <!-- Image Present -->
                          <!-- Generate Button -->
                          @if (!params) {
                            <div class="btn-generate-sec">
                              <button class="btn btn-dark" (click)="generatePortrait($event)">
                                Generate <img src="assets/icons/icon-generate.svg" alt="" />
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
            <!-- Created by / Distribution: side by side under the Overview row -->
            <div class="acc-pair-row">
              <div class="acc-card createdby">
                <h4>Created by / For</h4>
                <div class="cf-grid cf-grid--1">
                  <div class="cf-field">
                    <span class="cf-label">Creator</span>
                    <input type="text" formControlName="creator" />
                  </div>
                  <div class="cf-field">
                    <span class="cf-label">Date created</span>
                    <input type="text" formControlName="created_at" class="date-input" />
                  </div>
                </div>
              </div>
              <div class="acc-card distribution">
                <h4>Distribution &amp; Compatibility</h4>
                <div class="cf-grid cf-grid--2">
                  <div class="cf-field">
                    <span class="cf-label">Digital Readiness Level @if (creatorDetailsForm.get('digital_readiness_level')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                    <ng-select class="wt-select" formControlName="digital_readiness_level" [items]="digitalReadinessLevels"
                    placeholder="Select Digital Readiness Level" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Select Digital Readiness Level' }}</span></ng-template>
                    </ng-select>
                  </div>
                  <div class="cf-field">
                    <span class="cf-label">VTT Compatible @if (creatorDetailsForm.get('virtual_table_top')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                    <ng-select [items]="vttCompatibleLevels" [multiple]="true" [closeOnSelect]="false" formControlName="virtual_table_top"
                    placeholder="Select VTT Compatible" class="wt-select limited-height-select" appendTo="body" [hideSelected]="false">
                    </ng-select>
                  </div>
                  <div class="cf-field cf-span-all">
                    <span class="cf-label">License Type @if (creatorDetailsForm.get('license_type')?.errors?.['required']) {<span class="required-star">*</span>}</span>
                    <ng-select class="wt-select" formControlName="license_type" [items]="licenseTypes"
                    bindValue="label" bindLabel="label" placeholder="Select License Type" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Select License Type' }}</span></ng-template>
                    <ng-template ng-option-tmp let-item="item"><span [title]="item.description || ''">{{ item.label }}</span></ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
                    <div class="char-description">
                      <div class="d-flex align-items-center gap-1">
                        <h4>Description</h4>
                        @if (
                          creatorDetailsForm.get('description')?.errors?.['required'] ||
                          creatorDetailsForm.get('description')?.errors?.[
                          'trimmedMinLength'
                          ]?.['actualLength']
                          ) {
                          <span
                            class="required-star"
                            >*</span
                            >
                        }
                        @if (
                          creatorDetailsForm.get('description')?.errors?.[
                          'trimmedMinLength'
                          ]?.['actualLength']
                          ) {
                          <div
                            class="text-danger mx-2"
                            >
                            Description must be at least 100 characters
                          </div>
                        }
                      </div>
                      <div class="char-description-wrapper">
                        <textarea formControlName="description"></textarea>
                      </div>
                    </div>
                    <!--
                    The main container uses the "row" class, which acts as a flex container
                    for the columns inside it. This is a standard Bootstrap approach.
                    -->
                    <div class="row gy-4">
                      <!--
                      Column 1: Map Files Section.
                      - "col-lg-6" makes this column take up half the width on large screens.
                      - "col-12" makes it take up the full width on smaller screens, causing it to stack.
                      - The heading is now grouped with its content.
                      -->
                      <div class="col-lg-6 col-12">
                        <div class="acc-files-head">
                          <h4>
                            Map Files
                            @if (mapImageFilesArray.controls.length === 0) {
                              <span class="required-star">*</span>
                            }
                          </h4>
                        </div>
                        <div class="content-file-sec">
                          <div class="file-items-row">
                            <!-- EACH FILE ITEM -->
                            @for (
                              fileControl of mapImageFilesArray.controls; track
                              fileControl; let i = $index) {
                              <div class="file-item-horizontal"
                                >
                                <div class="file-name" [title]="fileControl.value?.name">
                                  {{ fileControl.value?.name }}
                                </div>
                                @if (fileControl.value?.size) {
                                  <button type="button" class="btn-fminus" (click)="removeFileInput(i, fileControl)">
                                    <img src="assets/icons/icon-remove.svg" alt="Remove" />
                                  </button>
                                }
                                <!-- ERRORS -->
                                @if (fileControl.invalid) {
                                  <div class="error-messages">
                                    @if (fileControl.errors?.['required']) {
                                      <div>
                                        File is required.
                                      </div>
                                    }
                                    @if (fileControl.errors?.['invalidFileType']) {
                                      <div>
                                        Only specified file types allowed.
                                      </div>
                                    }
                                    @if (fileControl.errors?.['fileSizeExceeds']) {
                                      <div>
                                        File size exceeds 25MB.
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            <!-- NO FILE MESSAGE -->
                            @if (mapImageFilesArray.length === 0) {
                              <div class="no-files-message">
                                No Map files uploaded yet.
                              </div>
                            }
                          </div>
                          <!-- FORM ERRORS (GLOBAL) -->
                          @if (
                            creatorDetailsForm.controls['adventure_writeup'].invalid &&
                            (creatorDetailsForm.controls['adventure_writeup'].dirty ||
                            creatorDetailsForm.controls['adventure_writeup'].touched)
                            ) {
                            <div
                              class="form-errors"
                              >
                              @if (
                                creatorDetailsForm.controls['files'].errors?.['minFiles']
                                ) {
                                <div
                                  >
                                  You must upload at least {{ minFilesRequired }} file(s).
                                </div>
                              }
                              @if (
                                creatorDetailsForm.controls['files'].errors?.['maxFiles']
                                ) {
                                <div
                                  >
                                  You can upload a maximum of {{ maxFilesLimit }} files.
                                </div>
                              }
                            </div>
                          }
                          <!-- TOTAL SIZE OVERFLOW -->
                          @if (
                            creatorDetailsForm.controls['adventure_writeup'].errors?.[
                            'totalFileSizeExceeds'
                            ]
                            ) {
                            <div class="file-error text-center mt-2"
                              >
                              Total file size exceeds
                              {{
                              creatorDetailsForm.controls["adventure_writeup"].errors?.[
                              "totalFileSizeExceeds"
                              ]?.formattedMax
                              }}. Current total:
                              {{
                              creatorDetailsForm.controls["adventure_writeup"].errors?.[
                              "totalFileSizeExceeds"
                              ]?.formattedActual
                              }}.
                            </div>
                          }
                          <!-- ADD BUTTON -->
                          <div class="file-upload-controls d-flex flex-column align-items-center">
                            <button type="button" class="btn btn-green mt-2" (click)="docInputImage.click()" [disabled]="!isEditable">
                              Upload
                            </button>
                            <input type="file" multiple (change)="onFileSelected($event)" #docInputImage style="display: none"
                              [accept]="allowedMimeTypesForMapFiles" />
                            </div>
                          </div>
                        </div>
                        <!--
                        Column 2: Adventure Write Up Section.
                        - This follows the same responsive logic as the first column.
                        -->
                        <div class="col-lg-6 col-12">
                          <div class="acc-files-head">
                            <h4>
                              Adventure Write Up
                              @if (mapFilesArray.controls.length === 0) {
                                <span class="required-star">*</span>
                              }
                            </h4>
                          </div>
                          <div class="content-file-sec">
                            <!-- ALL FILE ITEMS -->
                            <div class="file-items-row">
                              <!-- EACH FILE ITEM -->
                              @for (
                                fileControl of mapFilesArray.controls; track
                                fileControl; let i = $index) {
                                <div class="file-item-horizontal"
                                  >
                                  <div class="file-name" [title]="fileControl.value?.name">
                                    {{ fileControl.value?.name }}
                                  </div>
                                  @if (fileControl.value?.size) {
                                    <button type="button" class="btn-fminus" (click)="removeMapFileInput(i, fileControl)"
                                      >
                                      <img src="assets/icons/icon-remove.svg" alt="Remove" />
                                    </button>
                                  }
                                  <!-- INDIVIDUAL FILE ERRORS -->
                                  @if (fileControl.invalid) {
                                    <div class="error-messages">
                                      @if (fileControl.errors?.['required']) {
                                        <div class="file-error">
                                          File is required.
                                        </div>
                                      }
                                      @if (fileControl.errors?.['invalidFileType']) {
                                        <div class="file-error">
                                          Only Specified typed files are allowed.
                                        </div>
                                      }
                                      @if (fileControl.errors?.['fileSizeExceeds']) {
                                        <div class="file-error">
                                          File size exceeds 25MB.
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                              <!-- NO FILE MESSAGE -->
                              @if (mapFilesArray.length === 0) {
                                <div class="no-files-message">
                                  No write-ups uploaded yet.
                                </div>
                              }
                            </div>
                            <!-- GLOBAL FORM ERRORS -->
                            @if (
                              creatorDetailsForm.controls['map_files'].invalid &&
                              (creatorDetailsForm.controls['map_files'].dirty ||
                              creatorDetailsForm.controls['map_files'].touched)
                              ) {
                              <div class="form-errors"
                                >
                                @if (
                                  creatorDetailsForm.controls['files'].errors?.['minFiles']
                                  ) {
                                  <div
                                    >
                                    You must upload at least {{ minFilesRequired }} file(s).
                                  </div>
                                }
                                @if (
                                  creatorDetailsForm.controls['files'].errors?.['maxFiles']
                                  ) {
                                  <div
                                    >
                                    You can upload a maximum of {{ maxFilesLimit }} files.
                                  </div>
                                }
                              </div>
                            }
                            <!-- TOTAL SIZE WARNING -->
                            @if (
                              creatorDetailsForm.controls['map_files'].errors?.[
                              'totalFileSizeExceeds'
                              ]
                              ) {
                              <div class="file-error text-center mt-2"
                                >
                                Total file size exceeds
                                {{
                                creatorDetailsForm.controls["map_files"].errors?.[
                                "totalFileSizeExceeds"
                                ]?.formattedMax
                                }}. Current total:
                                {{
                                creatorDetailsForm.controls["map_files"].errors?.[
                                "totalFileSizeExceeds"
                                ]?.formattedActual
                                }}.
                              </div>
                            }
                            <!-- ADD BUTTON -->
                            <div class="file-upload-controls d-flex flex-column align-items-center">
                              <button type="button" class="btn btn-green text-center flex-column mt-2" (click)="docInput.click()"
                                [disabled]="!isEditable">
                                Upload
                              </button>
                              <input type="file" multiple (change)="onFileSelectedMapFiles($event)" #docInput style="display: none"
                                [accept]="allowedMimeTypes" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="pd-card acc-thumbs-card">
                          <h4>Thumbnails</h4>
                          <!-- Generated server-side from the map images above (the old manual
                               upload here was never sent to the API). New picks preview locally. -->
                          <p class="thumb-note">Generated automatically from your map images.</p>
                          @if (mapThumbnails.length) {
                            <div class="row">
                              @for (thumb of mapThumbnails; track thumb.src) {
                                <div class="col-md-6 image-wrapper mb-2">
                                  <div class="inner-image-wrapper">
                                    <img [src]="thumb.src" [alt]="thumb.name" [title]="thumb.name" />
                                  </div>
                                </div>
                              }
                            </div>
                          } @else {
                            <div class="no-files-message">Upload a map image above and its thumbnail will appear here.</div>
                          }
                        </div>
                            @if (!contentData || contentData?.owned) {
                              <div class="content-heading">OPTIONAL information</div>
                            }
                            @if (!contentData || contentData?.owned) {
                              <div class="adv-checkbox">
                                <h4>Adventure PLAYABLE in (Used in Search filtering)</h4>
                                <div class="adv-checkbox-wrap">
                                  <div formGroupName="elevation" class="adv-list">
                                    <div class="adv-list">
                                      <!-- Elevation "select all" checkbox -->
                                      <div class="form-check-b">
                                        <label>Elevation</label>
                                        <input type="checkbox" formControlName="selectAll" />
                                      </div>
                                      <!-- Child range checkboxes -->
                                      <ng-container formArrayName="ranges">
                                        @for (
                                          range of elevationRangeRows.controls; track
                                          range; let i = $index) {
                                          <div
                                            [formGroupName]="i"
                                            class="form-check-b"
                                            >
                                            <label>{{ elevationRanges[i] }}</label>
                                            <input type="checkbox" formControlName="selected" />
                                          </div>
                                        }
                                      </ng-container>
                                    </div>
                                  </div>
                                  <div formGroupName="geozone" class="adv-list">
                                    <div class="adv-list">
                                      <!-- Geozone "select all" checkbox -->
                                      <div class="form-check-b">
                                        <label>Geozone</label>
                                        <input type="checkbox" formControlName="selectAll" />
                                      </div>
                                      <!-- Child range checkboxes -->
                                      <ng-container formArrayName="ranges">
                                        @for (
                                          range of geozoneRangeRows.controls; track
                                          range; let i = $index) {
                                          <div
                                            [formGroupName]="i"
                                            class="form-check-b"
                                            >
                                            <label>{{ geozoneRanges[i] }}</label>
                                            <input type="checkbox" formControlName="selected" />
                                          </div>
                                        }
                                      </ng-container>
                                    </div>
                                  </div>
                                  <div formGroupName="biome" class="adv-list">
                                    <div class="adv-list">
                                      <!-- Geozone "select all" checkbox -->
                                      <div class="form-check-b">
                                        <label>Biome</label>
                                        <input type="checkbox" formControlName="selectAll" />
                                      </div>
                                      <!-- Child range checkboxes -->
                                      <ng-container formArrayName="ranges">
                                        @for (
                                          range of biomeRangeRows.controls; track
                                          range; let i = $index) {
                                          <div
                                            [formGroupName]="i"
                                            class="form-check-b"
                                            >
                                            <label>{{ biomeRanges[i] }}</label>
                                            <input type="checkbox" formControlName="selected" />
                                          </div>
                                        }
                                      </ng-container>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (!contentData || contentData?.owned) {
                              <div class="adv-checkbox">
                                <div class="adv-checkbox-wrap">
                                  <div formGroupName="ruralLocation" class="adv-list">
                                    <div class="adv-list">
                                      <!-- Geozone "select all" checkbox -->
                                      <div class="form-check-b">
                                        <label>Rural Location</label>
                                        <input type="checkbox" formControlName="selectAll" />
                                      </div>
                                      <!-- Child range checkboxes -->
                                      <ng-container formArrayName="ranges">
                                        @for (
                                          range of ruralLocationRows.controls; track
                                          range; let i = $index) {
                                          <div
                                            [formGroupName]="i"
                                            class="form-check-b"
                                            >
                                            <label>{{ ruralLocationRanges[i] }}</label>
                                            <input type="checkbox" formControlName="selected" />
                                          </div>
                                        }
                                      </ng-container>
                                    </div>
                                  </div>
                                  <div formGroupName="urbanLocation" class="adv-list">
                                    <div class="adv-list">
                                      <!-- Geozone "select all" checkbox -->
                                      <div class="form-check-b">
                                        <label>Urban Location</label>
                                        <input type="checkbox" formControlName="selectAll" />
                                      </div>
                                      <!-- Child range checkboxes -->
                                      <ng-container formArrayName="ranges">
                                        @for (
                                          range of urbanLocationRows.controls; track
                                          range; let i = $index) {
                                          <div
                                            [formGroupName]="i"
                                            class="form-check-b"
                                            >
                                            <label>{{ urbanLocationRanges[i] }}</label>
                                            <input type="checkbox" formControlName="selected" />
                                          </div>
                                        }
                                      </ng-container>
                                    </div>
                                  </div>
                                  <div formGroupName="shops" class="adv-list">
                                    <div class="adv-list">
                                      <!-- Geozone "select all" checkbox -->
                                      <div class="form-check-b">
                                        <label>Shops</label>
                                        <input type="checkbox" formControlName="selectAll" />
                                      </div>
                                      <!-- Child range checkboxes -->
                                      <ng-container formArrayName="ranges">
                                        @for (range of shopsRows.controls; track range; let i = $index) {
                                          <div [formGroupName]="i" class="form-check-b">
                                            <label>{{ shopsRanges[i] }}</label>
                                            <input type="checkbox" formControlName="selected" />
                                          </div>
                                        }
                                      </ng-container>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
              </div>
              <div class="add-cc-btnsec">
                @if (isEditable) {
                  <button class="btn btn-theme btn-sm save-button" (click)="onSave()" [disabled]="isSaving"
                    type="button">
                    {{ isSaving ? "Saving..." : "Save" }}
                  </button>
                }
                <button class="btn btn-dark btn-sm" type="button" (click)="onBack()">
                  Cancel
                </button>
                @if (params && params == 'edit') {
                  <button class="btn btn-dark btn-sm" type="button" (click)="report()">
                    Report
                  </button>
                }
              </div>
            </div>
          </form>
        </div>
      }
    </div>
    <app-footer></app-footer>
